export const environment = {
  production: true,
  apiUrl: 'https://gfx5z5ts40.execute-api.us-east-1.amazonaws.com/prod/api/v1',
};
